import axios from "axios";
import config from "./index";

const baseURL = config.apiUrl;

export default axios.create({
  baseURL: baseURL,
});
export const rawAxios = axios.create({
  baseURL: baseURL,
});
export const axiosBroadcast = axios.create({
  baseURL: config.broadcastApiUrl,
});
export const axiosUploader = axios.create({
  baseURL: config.uploaderApiUrl,
});
export const axiosMock = axios.create({
  baseURL: config.mockApi,
});
export const walletAxios = axios.create({
  baseURL: config.walletApiUrl,
});
export const axiosLocalhost = axios.create({
  baseURL: config.localhostUrl,
});
export const axiosProd = axios.create({
  baseURL: config.membersUrl,
});
export const affAxios = axios.create({
  baseURL: "https://adultfriendfinder.com/",
});
export const classicCamsAxios = axios.create({
  baseURL: config.classicCamsApiUrl,
});
export const camsAxios = axios.create({
  baseURL: config.camsApiUrl,
});

export const cancelToken = axios.CancelToken;
